var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _Basic = require("../../../elements/Basic");

var _PublishingInfoText = _interopRequireDefault(require("./PublishingInfoText"));

var _FontelloIcon = _interopRequireDefault(require("../Basic/FontelloIcon"));

var _Touchable = _interopRequireDefault(require("../Basic/Touchable"));

var _PropsHelper = require("../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Teaser/index.js";

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var Teaser = function (_React$Component) {
  (0, _inherits2.default)(Teaser, _React$Component);

  var _super = _createSuper(Teaser);

  function Teaser(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Teaser);
    _this = _super.call(this, props);

    _this.shouldComponentUpdate = function (nextProps, nextState) {
      return !(0, _isEqual.default)((0, _omit.default)(nextProps, ['content', 'onSharePress', 'onBookmarkPress', 'onPress']), (0, _omit.default)(_this.props, ['content', 'onSharePress', 'onBookmarkPress', 'onPress'])) || nextState.markedAsBookmark !== _this.state.markedAsBookmark;
    };

    _this.onBookmarkClick = function () {
      _this.setState({
        markedAsBookmark: !_this.state.markedAsBookmark
      });

      if (typeof _this.props.onBookmarkPress === 'function') {
        _this.props.onBookmarkPress(_this.props);
      }
    };

    _this.state = {
      markedAsBookmark: props.markedAsBookmark || false
    };
    return _this;
  }

  (0, _createClass2.default)(Teaser, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          headline = _this$props.headline,
          content = _this$props.content,
          subHeadline = _this$props.subHeadline,
          publishedAt = _this$props.publishedAt,
          origin = _this$props.origin,
          onSharePress = _this$props.onSharePress,
          onBookmarkPress = _this$props.onBookmarkPress,
          onPress = _this$props.onPress,
          href = _this$props.href,
          nofollow = _this$props.nofollow,
          type = _this$props.type,
          _this$props$mb = _this$props.mb,
          mb = _this$props$mb === void 0 ? 2 : _this$props$mb;
      return _react.default.createElement(_Basic.Column, {
        isFlex: true,
        mb: mb,
        borderX: 1,
        borderY: 1,
        borderColor: "border.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 71,
          columnNumber: 13
        }
      }, _react.default.createElement(_Touchable.default, {
        onPress: type !== 'youtube' ? (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress, (0, _omit.default)(this.props, ['content'])) : undefined,
        href: href,
        rel: (0, _PropsHelper.getValueConditionally)(nofollow, 'nofollow'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 72,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Column, {
        p: 2,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 84,
          columnNumber: 21
        }
      }, headline ? _react.default.createElement(_Basic.Text, {
        bold: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 85,
          columnNumber: 37
        }
      }, headline) : null, subHeadline ? _react.default.createElement(_Basic.Text, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 86,
          columnNumber: 40
        }
      }, subHeadline) : null), _react.default.createElement(_Basic.Row, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 88,
          columnNumber: 21
        }
      }, content())), _react.default.createElement(_Basic.Row, {
        center: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.View, {
        flexing: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 91,
          columnNumber: 21
        }
      }, type === 'ad' ? _react.default.createElement(_Basic.Text, {
        size: "small",
        mx: 2,
        my: 1,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 93,
          columnNumber: 29
        }
      }, "- w -") : _react.default.createElement(_PublishingInfoText.default, {
        flexing: true,
        publishingDate: publishedAt,
        source: origin,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 29
        }
      })), onBookmarkPress && _react.default.createElement(_Touchable.default, {
        onPress: this.onBookmarkClick,
        hitSlop: {
          top: 8,
          bottom: 8,
          left: 8,
          right: 8
        },
        skipDebounce: true,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105,
          columnNumber: 25
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        size: "custom",
        fontSize: 23,
        mx: 14,
        name: this.state.markedAsBookmark ? 'bookmark-fill' : 'bookmark',
        color: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 110,
          columnNumber: 29
        }
      })), onSharePress && _react.default.createElement(_Touchable.default, {
        mr: 2,
        onPress: onSharePress,
        hitSlop: {
          top: 8,
          bottom: 8,
          left: 8,
          right: 8
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 120,
          columnNumber: 25
        }
      }, _react.default.createElement(_FontelloIcon.default, {
        size: "custom",
        fontSize: 23,
        name: "share",
        color: "font.main",
        __source: {
          fileName: _jsxFileName,
          lineNumber: 125,
          columnNumber: 29
        }
      }))));
    }
  }]);
  return Teaser;
}(_react.default.Component);

Teaser.propTypes = {
  headline: _propTypes.default.string,
  subHeadline: _propTypes.default.string,
  publishedAt: _propTypes.default.string,
  origin: _propTypes.default.string,
  onSharePress: _propTypes.default.func,
  onBookmarkPress: _propTypes.default.func,
  onPress: _propTypes.default.func,
  markedAsBookmark: _propTypes.default.bool,
  content: _propTypes.default.func
};
Teaser.defaultProps = {
  content: function content() {}
};
var _default = Teaser;
exports.default = _default;